import { t } from '@/features/i18n/utils';
import { createFileRoute } from '@tanstack/react-router';
import { Main } from '@/ui/components/main';
import { Header, HeaderBackButton, HeaderChatButton } from '@/ui/components/header';
import { ProjectBreadcrumbs } from '@/features/projects/components/project-breadcrumbs';
import { BreadcrumbPage } from '@/ui/components/breadcrumb';
import { ArtifactsPage } from '@/features/artifacts/components/artifacts-page';
import { artifactsSearchSchema } from '@/features/artifacts/constants';

export const Route = createFileRoute('/_authed/project/$projectId/artifacts/')({
  component: RouteComponent,
  validateSearch: artifactsSearchSchema,
});

function RouteComponent() {
  return (
    <Main>
      <Header>
        <HeaderBackButton />
        <ProjectBreadcrumbs>
          <BreadcrumbPage>{t({ en: 'Working documents', nb: 'Arbeidsdokumenter' })}</BreadcrumbPage>
        </ProjectBreadcrumbs>
        <HeaderChatButton />
      </Header>
      <ArtifactsPage />
    </Main>
  );
}
